var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import omit from "lodash/omit";
import fr from "date-fns/locale/fr";
import enGB from "date-fns/locale/en-GB";
import getCurrentLocale from "@irati/utils/lang/helpers/getCurrentLocale";
import { ValidationInput } from "@irati/utils/validation";
import { injectIntl } from "@irati/utils/lang";
import { FormGroup } from "../Form";
import ErrorText from "../ErrorText";
import HintText from "../HintText";
import "react-datepicker/dist/react-datepicker.css";
import { CalendarIcon, DatePickerWrapper } from "./styled/DatePicker";
registerLocale("fr-FR", fr);
registerLocale("en-GB", enGB);
registerLocale("en-AU", enGB);
var StockAddDetailsDatePicker = /** @class */ (function (_super) {
    __extends(StockAddDetailsDatePicker, _super);
    function StockAddDetailsDatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (value) {
            _this.setState({ value: value });
            _this.props.onChange(moment(value));
        };
        _this.preventRawEditing = function (e) {
            e.preventDefault();
        };
        _this.state = {
            errorMsg: null,
            value: moment(props.value || undefined).toDate()
        };
        _this.validation = new ValidationInput(_this);
        return _this;
    }
    StockAddDetailsDatePicker.getDerivedStateFromProps = function (props, state) {
        var rawValue = props.value;
        if (rawValue) {
            var value = moment(rawValue).toDate();
            var stateValue = state.value;
            if (!stateValue || value.getTime() !== stateValue.getTime()) {
                return { value: value };
            }
            return null;
        }
        return null;
    };
    StockAddDetailsDatePicker.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.validation.update(prevProps, prevState);
    };
    StockAddDetailsDatePicker.prototype.componentWillUnmount = function () {
        this.validation.destroy();
    };
    StockAddDetailsDatePicker.prototype.render = function () {
        var _a = this.props, label = _a.label, hint = _a.hint, name = _a.name, className = _a.className, showTimeSelect = _a.showTimeSelect, icon = _a.icon, formatMessage = _a.formatMessage;
        var _b = this.state, errorMsg = _b.errorMsg, value = _b.value;
        var inputProps = omit(this.props, ["className", "name", "label", "hint", "value", "onChange", "validation"]);
        return (React.createElement(FormGroup, { className: className, controlId: name, validationState: errorMsg ? "error" : undefined },
            React.createElement(Col, { xs: 12 },
                React.createElement("label", { htmlFor: name }, label)),
            React.createElement(Col, { xs: 12 },
                React.createElement(DatePickerWrapper, null,
                    React.createElement(DatePicker, __assign({ locale: getCurrentLocale(), onChangeRaw: this.preventRawEditing, timeCaption: formatMessage({ id: "platform.web.ui.datePicker.timeCaption" }) }, inputProps, { timeFormat: "H:mm", dateFormat: showTimeSelect ? "dd/MM/yyyy H:mm" : "dd/MM/yyyy", selected: value, onChange: this.handleChange })),
                    icon && React.createElement(CalendarIcon, { icon: "calendar" })),
                errorMsg && (React.createElement("div", null,
                    React.createElement(ErrorText, { small: true }, errorMsg))),
                hint && (React.createElement("div", null,
                    React.createElement(HintText, { small: true }, hint))))));
    };
    StockAddDetailsDatePicker.defaultProps = {
        className: "",
        placeholderText: "Select a date",
        dropdownMode: "select",
        showYearDropdown: true,
        minDate: moment()
            .add(1, "days")
            .toDate(),
        showTimeSelect: false,
        icon: false
    };
    StockAddDetailsDatePicker.contextTypes = {
        currentScreen: PropTypes.string
    };
    return StockAddDetailsDatePicker;
}(Component));
export { StockAddDetailsDatePicker };
export default injectIntl(StockAddDetailsDatePicker);
